var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.883,
    height: 18.505,
    viewBox: "0 0 16.883 18.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edad",
    transform: "translate(-3 0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7696",
    "data-name": "Trazado 7696",
    d: "M11.442,23C6.779,23,3,25.52,3,28.628v2.814a.8.8,0,0,0,.8.8H19.079a.8.8,0,0,0,.8-.8V28.628C19.883,25.52,16.1,23,11.442,23Z",
    transform: "translate(0 -13.775)",
    fill: "#ed5564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7697",
    "data-name": "Trazado 7697",
    d: "M16.226,0a5.226,5.226,0,1,0,5.226,5.226A5.226,5.226,0,0,0,16.226,0Z",
    transform: "translate(-4.784 -0.021)",
    fill: "#fac591"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7698",
    "data-name": "Trazado 7698",
    d: "M22.039,1.989a5.226,5.226,0,0,0-8.229-.04.036.036,0,0,0,.028.056h8.2Z",
    transform: "translate(-6.461 0)",
    fill: "#84523c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.3aecf44a2e31680a29b4d3c1c202e1e1.svg";
export { ForwardRef as ReactComponent };